<template>
  <div class="pagelist">
    <ul>
      <li v-for="(item,i) in page" :class="current == i ? 'active' : ''" :key="i" @click="goPage(i)"></li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'PageList',
  props: ['page'],
  data() {
    return {
      current:0,
    }
  },
  methods: {
    goPage(i){
      this.current = i
      this.$emit('getPage',i+1)
    }
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.pagelist{
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  ul{
    display: flex;
    list-style: none;
    li{
      width: .25rem;
      height: .25rem;
      border-radius: .25rem;
      background: #a3a2a2;
      margin-right: .2rem;
      cursor: pointer;
    }
    li:last-child{
      margin-right: 0;
    }
    li.active{
      background: #7de5ff;
    }
  }
}
</style>
